angular.module('ngWig')
    .config(['ngWigToolbarProvider', function (ngWigToolbarProvider) {
       ngWigToolbarProvider.addCustomButton('img', 'nw-img-button');
    }])
    .component('nwImgButton', {
        bindings: {
            content: '=',
            execCommand: '=',
            editMode: '=',
            disabled: '='
        },
        template:  `<button type="button" ng-click="$ctrl.showUpload = !$ctrl.showUpload" ng-disabled="$ctrl.editmode || $ctrl.disabled" class="nw-button img" title="Add image">Add image</button>
        <div ng-show="$ctrl.showUpload" style="position: absolute; background: #fff; box-shadow: 0px 1px 10px rgba(0,0,0,0.5); z-index: 99">
            <div data-ng-show="!$ctrl.uploading" layout-padding layout="column" class="drop" ngf-select="$ctrl.uploadFile($file)" ngf-drop="$ctrl.uploadFile($file)" ngf-drag-over-class="'dragover'">
                <md-icon class="material-icons" aria-label="file_upload64" md-menu-align-target>file_upload</md-icon>
                Drag a file here or click to select.
            </div>

            <div data-ng-show="$ctrl.uploading">
                <md-progress-circular md-mode="indeterminate"></md-progress-circular>
            </div>
        </div>
        `,
        controller: function($mdDialog, $http, Upload, appUtils) {
            var main = this;

            this.uploadFile = function(file) {
                if(file === null) {
                    main.uploading = false;
                    return;
                }

                main.uploading = true;
                $http({
                    'method': 'POST',
                    'url': '/api/v1/admin/email/upload',
                    'data': {'extension': file.name.split('.').pop() }
                }).then(
                    function(response) {
                        appUtils.fileReaderUpload(
                            response.data.upload_url, response.data.content_type, file
                        ).then(
                            function() {
                                // ngWig hijacks execCommand('insertImage', url) so just adding it to the model
                                // main disadvantage here is that it will append rather than use cursor position
                                main.content +=  '<div><img src="' + response.data.filename + '" alt="" /></div>';
                                main.showUpload = false;
                                main.uploading = false;
                            }
                        );
                    },
                    function(response) {
                        main.showUpload = false;
                        main.uploading = false;
                    }
                );
            }
        }
    });
